'use strict';

module.exports = {
  furniture: 'furniture',
  nonFurniture: 'non_furniture',
};
